import Modal from "components/ui/Modal/Modal";
import React from "react";
import { useTranslation } from "react-i18next";

export interface CancelModalProps {
  isOpen: boolean;
  onOk?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onCancel?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CancelModal: React.FC<CancelModalProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      title={t("forgotPassword.cancelModal.title")}
      description={t("forgotPassword.cancelModal.description")}
      okText={t("forgotPassword.cancelModal.continueButtonText")}
      cancelText={t("forgotPassword.cancelModal.cancelButtonText")}
      type="alert"
      alertType={"warning"}
      showCancelButton
      size="large"
    />
  );
};

export default CancelModal;
